/**
 * This is table script.js file
 */

import ElementListCell from '@/components/element-list/element-list-cell/index.vue';

/* eslint-disable max-len */

export default {
    name       : 'ElementList',
    components : {
        ElementListCell
    },
    /**
     * @override
     */
    data() {
        return {
            cols : []
        };
    },
    props : {
        editable : {
            type     : Boolean,
            required : false,
            default: false
        },
        select : {
            type     : Boolean,
            required : false,
            default: true
        },
        header : {
            type     : String,
            required : true
        },
        headerSwitch: {
            type     : Boolean,
            required : false
        },
        headerSwitchAction: {
            type     : Function,
            required : false
        },
        headerSwitchVars: {
            type     : Array,
            required : false
        },
        items : {
            type     : Array,
            required : true
        },
        selectableItems : {
            type     : Array,
            required : false
        },
        selectableLoading: {
            type     : Boolean,
            default: false
        },
        selectLabel : {
            type     : String,
            required : false
        },
        selectPlaceholder : {
            type     : String,
            required : false
        },
        noElementsMessage : {
            type     : String,
            required : false
        },
        visible: {
            type     : Boolean,
            default: false
        }
    },
    methods: {
        /**
         * Consultamos el tipo de dato
         * @param {Object} val Objeto a valorar que tipo de dato es
         * @return {String} Tipo de dato (string/object)
         */
        getType(val) {
            return (typeof val);
        },
        // asyncFind() {
        // this.isLoading = true
        // ajaxFindCountry(query).then(response => {
        //     this.countries = response;
        //     this.isLoading = false;
        // })
        // },
        /**
         * Emit para enviar al padre los cambios
         * @param {String} type Tipo de dato (accion/objeto)
         * @param {Number} index Posición en el array
         * @param {Boolean} value Valor cambiado
         * @param {String} key Acción del crud
         */
        save(type, index, value, key) {
            console.warn(type, index, value, key);
            this.$emit('change', { type, index, value, key });
        },
        /**
         * Emit muti-select search-change event
         * @param {Object} event Search query
        */
        onSearchChange(event) {
            this.$emit('search-change', event);
        },
        /**
         * Emit muti-select select event
         * @param {Object} event Selected element
        */
        onSelect(event) {
            this.$emit('select', event);
        }
    }
};
